
import { HttpClient, HttpEvent } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { APP_CONFIG, IAppConfig } from '@app/core/config';
import { UtilsService } from '@app/core/services';
import { BankPaymentAdd } from '@app/views/pages/deposit/bank/models';
import { BankPaymentDetails } from '../models';

@Injectable({
	providedIn: 'root'
})
export class BankPaymentService {

	constructor(
		@Inject(APP_CONFIG) private appConfig: IAppConfig,
		private httpClient: HttpClient,
		private utilsService: UtilsService
	) { }


	addBankPayment(bankPayment: BankPaymentAdd): Observable<any> {
		const formData: FormData = new FormData();

		for (const key in bankPayment) {
			if (bankPayment.hasOwnProperty(key)) {

				if (bankPayment[key] instanceof File) {
					formData.append(this.utilsService.upperCaseFirstLetter(key), bankPayment[key], bankPayment[key].name);
				} else {
					formData.append(this.utilsService.upperCaseFirstLetter(key), bankPayment[key]);
				}
			}
		}

		return this.httpClient
			.post<BankPaymentAdd>(`${this.appConfig.apiEndpoint}/new-core/payments/bank`, formData, {
				reportProgress: true,
				observe: 'events'
			})
			.pipe(map(response => response || {} as HttpEvent<any>));
	}

	downloadDocument(paymentId: string, fileDownloadName: string): Observable<any> {
		const url = `${this.appConfig.apiEndpoint}/new-core/payments/bank/${paymentId}/attachments/${fileDownloadName}/download`;

		return this.httpClient.get(url, { observe: 'response', responseType: 'blob' });
	}
}